@if (recipeOverview.recipe) {
  <div class="row">
    @if (!isMobile$) {
      <div class="col-m-11 col-24">
        <ng-container *ngTemplateOutlet="recipeMedia" />
      </div>
    }
    <div class="c__content col-m-12 offset-m-1 col-24">
      <section>
        <div class="c__recipe-header">
          <div class="c__wrapper-tags">
            @if (recipeOverview?.tags) {
              <ul class="c__tags" sd-list-inline>
                @for (tag of recipeOverview?.tags; track tag) {
                  <li>
                    <sd-tag [brand]="brand" [tagData]="tag" />
                  </li>
                }
              </ul>
            }
            @if (recipeOverview?.brandLogo?.media) {
              <sd-banner
                class="c__brand-logo"
                [isFit]="true"
                [media]="recipeOverview?.brandLogo?.media"
              />
            }
          </div>
          <div class="c__recipe-header-title-wrapper">
            <sd-title customClass="brand--h1 c__title" [titleLevel]="1">
              {{ recipeOverview.recipe?.title }}
            </sd-title>
            @if (!isMobile$) {
              <sd-icon
                class="has-pointer"
                name="icon-printer"
                [size]="iconSizeEnum.large"
                (click)="onPrintClicked()"
              />
            }
          </div>
          <div class="c__recipe-header-rating-wrapper">
            @if (recipeOverview.recipe?.communityTopRecipe) {
              <sd-rating
                [ratings]="ratingData()"
                [readonly]="true"
                [showAverageRatingsLabel]="true"
                [wrapReviewsOnMobile]="true"
                [reviewsClickable]="recipeOverview.recipe?.communityTopRecipe.comments > 0"
                (reviewsClicked)="onReviewsClicked($event)"
                (reviewsSeeAllClicked)="onReviewsSeeAllClicked()"
              />
            }
            @if (isMobile$) {
              <sd-icon
                class="has-pointer"
                name="icon-printer"
                [size]="iconSizeEnum.large"
                (click)="onPrintClicked()"
              />
            }
          </div>
        </div>
        @if (isMobile$) {
          <ng-container *ngTemplateOutlet="recipeMedia" />
        }
        <div class="c__recipe-timer">
          <sd-timer
            [timeOverview]="recipeOverview.timeOverview"
            [recipeUser]="recipeOverview?.user"
          />
        </div>
      </section>
      @if (recipeOverview?.recipeDevices?.devices) {
        <aside class="c__recipe-devices {{isReworked ? 'has-reworked-recipe' : ''}}">
          @if (recipeOverview?.recipeDevices?.devices.length > 0) {
            <sd-devices
              [devices]="recipeOverview?.recipeDevices?.devices"
              [maxProductDisplayed]="recipeOverview?.recipeDevices?.maxProductDisplayed"
              [push]="recipeOverview?.recipeDevices?.push"
              [title]="'recipes.devices.title' | translate"
              (deviceIsClicked)="onDeviceIsClicked($event)"
              (devicePushIsClicked)="onDevicePushIsClicked($event)"
            />
          }
        </aside>
      }
      <!-- Improved Recipe -->
      @if (isReworked) {
        <div class="c__recipe-improved">
          <div class="c__recipe-improved-wrapper">
            <sd-banner [media]="{ url: 'recipes.recipeImproved.icon' | translate }" [isFit]="true" />
            <div class="c__recipe-improved-text">
              <p class="is-caption is-bold">{{'recipes.recipeImproved.title' | translate}}</p>
              <p class="is-caption is-medium">{{'recipes.recipeImproved.description' | translate}}</p>
            </div>
          </div>
        </div>
      }
      <!-- Ingredients -->
      @if (recipeOverview?.recipe?.ingredients?.length > 0) {
        <section>
          <div class="c__recipe-block-header">
            <sd-title [titleLevel]="2" customClass="brand--h3">
              {{'recipes.blockIngredients.title' | translate}}
            </sd-title>
            @if (recipeOverview?.recipe?.yield?.quantity && recipeOverview?.yieldSelectable) {
              <sd-form-increment
                [labelTitle]="recipeOverview?.recipe?.yield.quantity > 1 ? recipeOverview?.recipe.yield.unit.pluralName : recipeOverview?.recipe?.yield.unit.name"
                [currentValue]="recipeOverview?.recipe?.yield?.quantity"
                [minValue]="recipeOverview?.yieldMin"
                [maxValue]="recipeOverview?.yieldMax"
                [choiceOptions]="getYieldOptions(recipeOverview?.recipe)"
                (updateValue)="onUpdateValue($event)"
              />
            }
          </div>
          <div class="c__recipe-block-content">
            <ul sd-list-inline class="c__ingredients-list">
              @for (ingredient of recipeOverview?.recipe?.ingredients; track ingredient) {
                <li class="c__ingredient-wrapper">
                  <p class="is-body-s is-medium">
                    @if (!!ingredient.quantity) {
                      @if (ingredient.unit) {
                        <span class="is-text-brand is-bold">
                        {{ 'recipes.ingredient.quantityUnit' | translate: {quantity: ingredient.quantity, unit: ingredient.unit?.abbreviation
                            ? ingredient.unit?.abbreviation
                            : ingredient.quantity > 1
                              ? ingredient.unit?.pluralName
                                ? ingredient.unit?.pluralName
                                : ingredient.unit?.name
                              : ingredient.unit?.name}
                          }}
                      </span>
                      } @else {
                        <span class="is-text-brand is-bold">{{ ingredient.quantity }}</span>
                      }
                    }
                    {{ingredient?.name}}
                  </p>
                </li>
              }
            </ul>
            @if (ingredientsDisclaimer.length && recipeOverview?.recipe?.isAutomaticallyGenerated) {
              <sd-footnote [footNotes]="footNotesDisclaimer" />
            }
          </div>
        </section>
      }
      <!-- Kitchenwares   -->
      @if (recipeOverview?.recipe?.kitchenwares?.length > 0) {
        <section>
          <div class="c__recipe-block-header">
            <sd-title [titleLevel]="2" customClass="brand--h3">
              {{'recipes.blockKitchenwares.title' | translate}}
            </sd-title>
          </div>
          <div class="c__recipe-block-content">
            <sd-devices
              [devices]="recipeOverview?.recipe?.kitchenwares"
              [isSmall]="true"
              [isHovered]="false"
              (deviceIsClicked)="onDeviceIsClicked($event)"
            />
          </div>
        </section>
      }
      <!-- Steps   -->
      @if (recipeOverview?.recipe?.steps?.length > 0) {
        <section>
          <div class="c__recipe-block-header">
            <sd-title [titleLevel]="2" customClass="brand--h3">
              {{'recipes.blockPreparation.title' | translate}}
            </sd-title>
          </div>
          @for (step of recipeOverview?.recipe?.steps; track step) {
            <div class="c__recipe-block-content c__recipe-block-content-step">
              @if ($count > 1) {
                <p class="c__step-index is-body-s">
                <span class="is-text-brand is-bold">
                  {{ "recipes.step.title" | translate }} {{ ($index + 1) }}
                </span>
                  <span class="is-medium">
                  /{{ $count }}
                </span>
                </p>
              }
              <p class="c__step-description brand--h5">
                {{ step.description }}
              </p>
              @if (step.ingredients && step.ingredients.length) {
                <ul
                  class="c__step-ingredients">
                  @for (ingredient of step.ingredients; track ingredient) {
                    <li class="c__step-icon-item">
                      <sd-icon name="icon-ingredient" [size]="iconSizeEnum.medium" />
                      <span class="is-medium">{{ ingredient.quantity }}{{ ingredient.unit?.abbreviation }} {{ ingredient.name }}</span>
                    </li>
                  }
                </ul>
              }
              @if (step.kitchenwares && step.kitchenwares.length) {
                <ul class="c__step-kitchenwares">
                  @for (kitchenware of step.kitchenwares; track kitchenware) {
                    <li class="c__step-icon-item">
                      <sd-icon name="icon-kitchenware" [size]="iconSizeEnum.medium" />
                      <span class="is-medium">{{ kitchenware.text }}</span>
                    </li>
                  }
                </ul>
              }
              @if (step.parameters && step.parameters.length) {
                <div class="c__step-footer">
                  <ul sd-list-inline class="is-m">
                    @for (parameter of step.parameters; track parameter) {
                      @if (parameter.text) {
                        <li class="c__step-icon-item">
                          <sd-icon [name]="parameter.icon" [size]="iconSizeEnum.logo" />
                          <span class="is-bold">{{ parameter.text || "-" }}</span>
                        </li>
                      }
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </section>
      }
    </div>
  </div>
}

<ng-template #recipeMedia>
  <div class="c__recipe-media">
    <sd-banner
      class="c__media"
      [isComponentLoading]="isLoading"
      [media]="recipeOverview.media"
      [mediaTitle]="recipeOverview.recipe?.title"
      [imgRatio]="imageRatioEnum.r4_3"
      [twicPicsAutoSize]="false"
    />
    @if (!isMobile$ && recipeOverview.user) {
      <sd-recipe-user
        [isLoading]="isLoading"
        [user]="recipeOverview.user"
      />
    }
  </div>
</ng-template>
